
export default function DifferentiatorSection() {
  return (
    <section 
      id="about" 
      className="py-24 relative"
      style={{
        backgroundImage: 'url(https://static.readdy.ai/image/ccbd9e92c2e4555bab62a0921318c3e7/b2eac9ee580ec1ec1530ee19f3bccc37.jpeg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className="absolute inset-0 bg-black/60"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-light mb-6 text-white">
            About Us
          </h2>
          <div className="max-w-4xl mx-auto">
            <p className="text-lg font-light mb-8 text-white/90">
              In Swahili, USAWA means Equality — the principle that defines our approach. We bridge ambition and delivery, connecting local insight with global capital to transform vision into execution. Founded by leaders with experience on both sides of the table — from shaping national policy to structuring complex deals — USAWA turns opportunity into bankable growth for investors, governments and communities across Mozambique and the region.
            </p>
            <div className="mb-12">
              <h3 className="text-2xl font-light mb-4 text-white">
                Our Mission
              </h3>
              <p className="text-lg font-light text-white/90">
                To drive sustainable, inclusive development through expert market intelligence and strategic collaboration.
              </p>
            </div>
          </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm">
              <i className="ri-scales-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-medium mb-3 text-white">
              Equality
            </h3>
            <p className="font-light text-sm text-white/80">
              USAWA means equality in Swahili — the principle that defines our approach to every engagement
            </p>
          </div>
          
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm">
              <i className="ri-eye-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-medium mb-3 text-white">
              Transparency
            </h3>
            <p className="font-light text-sm text-white/80">
              We believe in open communication and honest relationships with all stakeholders
            </p>
          </div>
          
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm">
              <i className="ri-star-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-medium mb-3 text-white">
              Excellence
            </h3>
            <p className="font-light text-sm text-white/80">
              Delivering best-in-class solutions through deep expertise and rigorous execution
            </p>
          </div>
          
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm">
              <i className="ri-leaf-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-medium mb-3 text-white">
              Sustainability
            </h3>
            <p className="font-light text-sm text-white/80">
              Creating long-term value that benefits investors, governments, and communities
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
